import { render, staticRenderFns } from "./patientInvoices.vue?vue&type=template&id=54cd2a30&scoped=true"
import script from "./patientInvoices.vue?vue&type=script&lang=js"
export * from "./patientInvoices.vue?vue&type=script&lang=js"
import style0 from "./patientInvoices.vue?vue&type=style&index=0&id=54cd2a30&prod&lang=scss&scoped=true"
import style1 from "./patientInvoices.vue?vue&type=style&index=1&id=54cd2a30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cd2a30",
  null
  
)

export default component.exports